import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

const META = {
  de: {
    "/": {
      title: "ArStudio Solutions LLC — Ingenieur- & Architekturbüro | Remote Planung",
      description:
        "Internationales Ingenieurbüro für Bauingenieurwesen, Architektur, TGA und Elektroplanung. Ausführungsplanung, 3D-Visualisierung, Interior Design — remote geliefert.",
    },
    "/projekte/": {
      title: "Objekt Komercial Essen — Referenzprojekt | ArStudio Solutions",
      description:
        "Gewerbeobjekt in Essen mit Wellness, Gastronomie und Events. Ausführungs- und Elektroplanung durch ArStudio Solutions LLC.",
    },
    "/impressum": {
      title: "Impressum | ArStudio Solutions LLC",
      description: "Impressum gemäß § 5 TMG von ArStudio Solutions LLC, Ferizaj.",
    },
    "/datenschutz": {
      title: "Datenschutzerklärung | ArStudio Solutions LLC",
      description: "Datenschutzerklärung nach DSGVO von ArStudio Solutions LLC.",
    },
  },
  en: {
    "/": {
      title: "ArStudio Solutions LLC — Engineering & Architecture Office | Remote Planning",
      description:
        "International engineering office for civil, architecture, MEP and electrical planning. Construction docs, 3D visualization, interior design — delivered remote.",
    },
    "/projekte/": {
      title: "Commercial Object Essen — Reference Project | ArStudio Solutions",
      description:
        "Commercial object in Essen with wellness, hospitality and event spaces. Construction and electrical planning by ArStudio Solutions LLC.",
    },
    "/impressum": {
      title: "Legal Notice | ArStudio Solutions LLC",
      description: "Legal notice according to § 5 TMG by ArStudio Solutions LLC.",
    },
    "/datenschutz": {
      title: "Privacy Policy | ArStudio Solutions LLC",
      description: "GDPR privacy policy of ArStudio Solutions LLC.",
    },
  },
};

const setMeta = (name, content, attr = "name") => {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const SeoHead = () => {
  const { lang } = useLang();
  const location = useLocation();

  useEffect(() => {
    const dict = META[lang] || META.de;
    let key = location.pathname;
    if (key.startsWith("/projekte/") || key.startsWith("/projects/")) key = "/projekte/";
    const meta = dict[key] || dict["/"];

    document.title = meta.title;
    document.documentElement.lang = lang;
    setMeta("description", meta.description);
    setMeta("og:title", meta.title, "property");
    setMeta("og:description", meta.description, "property");
    setMeta("og:locale", lang === "de" ? "de_DE" : "en_US", "property");
    setMeta("og:url", `https://arstudio360.online${location.pathname}`, "property");
    setMeta("twitter:title", meta.title);
    setMeta("twitter:description", meta.description);

    // canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://arstudio360.online${location.pathname}`);
  }, [lang, location.pathname]);

  return null;
};

export default SeoHead;
